import { Menu, styled } from "@mui/material";


const MenuProfile = styled(Menu)(({  }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
}))

export default MenuProfile